import OrganisationApi from '@packages/organisations/api';

export class AdviserApi extends OrganisationApi {
    static resource = 'advisers';

    get endpoints() {
        return {
            ...super.endpoints,
            integrations: this.integrations.bind(this)
        };
    }

    async integrations(offset = null, limit = null, sort_by = null, filters = {}, config = { base_url: null }) {
        let extract = OrganisationApi.extractFilter(filters, 'adviser_id');

        if (!extract.value) {
            throw new Error(`adviser_id is required when requesting integrations for an adviser.`);
        }

        let url = `${config.base_url || this.base_url}`;

        if (extract.value) {
            url += `/${extract.value}`;
        }

        url += '/integrations';

        return this.index(offset, limit, sort_by, extract.filters, {
            ...config,
            base_url: url
        });
    }
}

export default AdviserApi;
